
import ListComponent from "../../../components/banners/Index.vue";

export default {
  components: {
    ListComponent
  }
}
